import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '../../reducers';
import * as youtubeModal from '../../actions/youtube-modal';

@Component({
  selector: 'edge-youtube-modal',
  templateUrl: './youtube-modal.component.html',
  styleUrls: ['./youtube-modal.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({ transform: 'scale3d(.3, .3, .3)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
      ])
    ])
  ]
})
export class YoutubeModalComponent {
  videoUrl: any;
  isVisible$: Observable<boolean>;
  videoId$: Observable<string>;

  constructor(
    private sanitizer: DomSanitizer,
    private store: Store<fromRoot.State>
  ) {
    this.isVisible$ = store.select(fromRoot.isYoutubeModalVisible);
    this.videoId$ = store.select(fromRoot.youtubeVideoId);

    this.videoUrl = this.videoId$.pipe(
      map((id) => {
        let videoUrl = '';
        if (id.includes('?list')) {
          videoUrl = `https://www.youtube.com/embed/videoseries${id}`;
        } else {
          videoUrl = `https://www.youtube.com/embed/${id}?rel=0&autoplay=1`;
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
      })
    );
  }

  close(show: boolean): void {
    this.store.dispatch(youtubeModal.ToggleYoutubeModalAction(show));
  }
}
